<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      d="M13.5 21v-7.5h2.6l.4-3h-3v-1.9c0-.87.24-1.46 1.48-1.46H17V4.42a20.96 20.96 0 0 0-2.27-.12c-2.25 0-3.79 1.38-3.79 3.9V10.5H8.4v3h2.54V21h2.56z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconFacebook',
  props: { size: { type: [String, Number], default: 24 } },
};
</script>
